export enum InitialApprovalStatus {
    Pending,
    Approved,
    Declined,
}